import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'
import { Layout } from './components/layout'
import { ProtectedRoute } from './components/auth'
import { ErrorFallback } from './components/ErrorFallback'
import { Dashboard, Inbox, RoundTables, Login, WorkOrders, Brains, Narratives } from './pages'

function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
          <Route path="/entities" element={<Navigate to="/" replace />} />
          <Route path="/transactions" element={<Navigate to="/" replace />} />
          <Route path="/portfolio" element={<Navigate to="/" replace />} />
          <Route path="/drive" element={<Navigate to="/" replace />} />
          <Route path="/chat" element={<Navigate to="/" replace />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/work-orders"
            element={
              <ProtectedRoute>
                <Layout>
                  <WorkOrders />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/inbox"
            element={
              <ProtectedRoute>
                <Layout>
                  <Inbox />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/round-tables"
            element={
              <ProtectedRoute>
                <Layout>
                  <RoundTables />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/brains"
            element={
              <ProtectedRoute>
                <Layout>
                  <Brains />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/narratives"
            element={
              <ProtectedRoute>
                <Layout>
                  <Narratives />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

export default App
